import { GlobalErrorType, IApiHeader } from "./appStoreTypes";
import { IFeedState, IProject } from "./feedStoreTypes";

export interface IDetailState extends IFeedState {
  tag?: string;
  categoryId?: string;
  selectedProject?: IProject;
  searchType: string;
}
export interface IInfoState {
  isMoreInfo: boolean;
  title?: string;
  description?: string;
}

export const initialInfoState: IInfoState = {
  isMoreInfo: false,
};

export interface IProgressState {
  id?: string;
  percentage?: number;
}
export interface IDownloadState extends IProgressState {
  isDownload: boolean;
}

export const initialDownloadState: IDownloadState = {
  isDownload: false,
};

export interface IInstallState extends IProgressState {
  isInstall: boolean;
}

export const initialInstallState: IInstallState = {
  isInstall: false,
};

export interface IUpdateState {
  type?: string;
  isUpdate: boolean;
}
export interface IErrorInfo {
  status?: number;
  errorCode?: number;
}
export interface IErrorState {
  status?: number;
  errorCode?: number;
}
export interface IDetailStore {
  detailState: IDetailState;
  onCopyDetailState: (state: IDetailState) => void;
  onGetDetailItem: (apiHeader: IApiHeader, projectId: string) => void;
  onUpdateDetailList: (apiHeader: IApiHeader) => void;

  detailStates: IDetailState[];
  onRevertDetailState: () => void;

  infoState: IInfoState;
  onUpdateInfoState: (state: IInfoState) => void;
  onResetInfoState: () => void;

  downloadState: IDownloadState;
  onDownloadStart: () => void;
  onDownloadCancel: () => void;
  onDownloadProgress: (args: string) => void;

  installState: IInstallState;
  onInstallProgress: (args: string) => void;
  onInstallComplete: (id: string) => void;
  completedProjects: string[];

  updateState: IUpdateState;
  onUpdateStart: (type: string) => void;
  onUpdateCancel: () => void;

  // detail local error
  errorState: IErrorState;
  onResetErrorState: () => void;

  // detail global error
  detailErrorState: GlobalErrorType;
  onUpdateDetailError: (type: GlobalErrorType) => void;
}
